import { Link } from 'react-router-dom';

const COMPARISON_ROWS = [
  { label: '初期の計画作成', excel: '手動でタスクを入力。フォーマットを整える必要がある', taskmanager: '資料をアップロードすればAIが自動でタスク分解', excelGood: true },
  { label: 'タスク分解', excel: '人が作業を洗い出し、表に記入', taskmanager: 'AIが資料を読み取り、タスク一覧を提案', excelGood: false },
  { label: '依存関係', excel: 'セルの位置や色で表現。変更時に手動更新が必要', taskmanager: '矢印で表示。遅延時に後続タスクへ自動反映', excelGood: false },
  { label: '日報との連動', excel: '別途回収し、人が進捗表に転記', taskmanager: 'AIが日報を解析し、タスクの進捗率を自動更新', excelGood: false },
  { label: '予定と実績', excel: '別シートで管理。比較に手間がかかる', taskmanager: 'ベースライン比較を自動表示。差異が一目で分かる', excelGood: false },
  { label: 'ファイル管理', excel: 'ファイルサーバーやメールで別管理', taskmanager: '資料をアップロードすればAIが内容を読み取り回答', excelGood: false },
  { label: '多言語', excel: '対応していない', taskmanager: '日本語・英語・タイ語のUIを切り替え可能', excelGood: false },
  { label: '国別祝日', excel: '手動で考慮する必要がある', taskmanager: 'メンバーごとに祝日を設定し、スケジュールへ自動反映', excelGood: false },
  { label: '情報検索', excel: 'ファイル名やフォルダ名で探す', taskmanager: 'AIが資料の内容を理解し、質問に対して根拠付きで回答', excelGood: false },
  { label: '最新情報の共有', excel: 'ファイルのバージョン管理が難しく、どれが最新か分からない', taskmanager: 'クラウド上で常に最新の情報を共有', excelGood: false },
];

export default function ExcelComparison() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-12">
          Excelでのプロジェクト管理から、AIで更新される管理へ
        </h2>

        <div className="overflow-x-auto -mx-4 px-4">
          <table className="w-full min-w-[768px] border-collapse">
            <thead>
              <tr className="border-b-2 border-background-300">
                <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-700 w-[180px]">比較項目</th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-foreground-700">
                  <i className="ri-file-excel-2-line text-green-600 mr-1"></i>
                  Excel・スプレッドシート
                </th>
                <th className="text-left py-3 px-4 text-sm font-semibold text-primary-700">
                  <i className="ri-task-line mr-1"></i>
                  ”おもいむすび”
                </th>
              </tr>
            </thead>
            <tbody>
              {COMPARISON_ROWS.map((row) => (
                <tr key={row.label} className="border-b border-background-200/70 hover:bg-background-50/50 transition-colors">
                  <td className="py-3 px-4 text-sm font-medium text-foreground-800">{row.label}</td>
                  <td className="py-3 px-4 text-sm text-foreground-600">{row.excel}</td>
                  <td className="py-3 px-4 text-sm text-foreground-700">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-check-line text-primary-500 text-xs"></i>
                      {row.taskmanager}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-12">
          <div className="bg-background-50 rounded-lg p-6 border border-background-200/70">
            <h3 className="text-base font-bold text-foreground-900 mb-3 flex items-center gap-2">
              <i className="ri-thumb-up-line text-green-600"></i>
              Excelが向いている場面
            </h3>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-green-500 mt-0.5 shrink-0"></i>
                導入しやすく、特別な準備が不要
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-green-500 mt-0.5 shrink-0"></i>
                自由に表を作成でき、カスタマイズ性が高い
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-green-500 mt-0.5 shrink-0"></i>
                少人数・短期案件の管理に向いている
              </li>
            </ul>
          </div>
          <div className="bg-primary-50 rounded-lg p-6 border border-primary-200/70">
            <h3 className="text-base font-bold text-foreground-900 mb-3 flex items-center gap-2">
              <i className="ri-rocket-line text-primary-600"></i>
              ”おもいむすび”が向いている場面
            </h3>
            <ul className="space-y-2 text-sm text-foreground-700">
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-primary-500 mt-0.5 shrink-0"></i>
                複数人で同時に進捗を更新する
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-primary-500 mt-0.5 shrink-0"></i>
                複数プロジェクトを横断的に管理する
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-primary-500 mt-0.5 shrink-0"></i>
                日報と進捗を自動で連動させたい
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-primary-500 mt-0.5 shrink-0"></i>
                資料や会話を一元化し、AIで検索したい
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-primary-500 mt-0.5 shrink-0"></i>
                海外チームと一緒に利用したい
              </li>
            </ul>
          </div>
        </div>

        <div className="text-center mt-8">
          <Link to="/compare/excel-vs-project-management-tool/" className="text-sm text-primary-600 hover:text-primary-700 font-medium inline-flex items-center gap-1">
            Excelと専用ツールの詳しい比較を見る <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}